import React from "react";
import { useTimer } from "react-timer-hook";
import './timer.css';

function MyTimer({ expiryTimestamp }) {
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn("onExpire called"),
  });
  // console.log({ seconds });
  // console.log({ minutes });
  // console.log({ hours });
  // console.log({ days });
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row-reverse" }}>
        <p style={{ marginRight: "3px" }} className="days-style">{days}</p>:<p style={{ marginLeft: "3px", marginRight: "3px" }} className="days-style">{hours}</p>:<p style={{ marginRight: "3px", marginLeft: "3px" }} className="days-style">{minutes}</p>:
        <p style={{ marginLeft: "3px" }} className="days-style">{seconds}</p>
      </div>
    </div>
  );
}

export default function App({ expir }) {
  return (
    <div>
      <MyTimer expiryTimestamp={expir} />
    </div>
  );
}
